import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export default function QrCode({ value, size = 160 }) {
  const [dataUrl, setDataUrl] = useState(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(value, {
      width: size,
      margin: 1,
      color: { dark: '#0a0a0f', light: '#ffffff' },
    }).then(url => { if (!cancelled) setDataUrl(url); })
      .catch(err => console.error('QR generation failed', err));
    return () => { cancelled = true; };
  }, [value, size]);

  if (!dataUrl) {
    return <div className="qr-placeholder" style={{ width: size, height: size }} />;
  }

  return <img className="qr-code" src={dataUrl} alt="QR-код для гостей" width={size} height={size} />;
}
